
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/primeur/[link]",
      function () {
        return require("private-next-pages/primeur/[link].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/primeur/[link]"])
      });
    }
  